import { Box, Center, Grid, Space, Text } from '@mantine/core';
import { memo } from 'react';
import { Link } from 'react-router-dom';
import { Button } from 'src/components/Button';
import { Checkbox } from 'src/components/Form/Checkbox';
import { InputEmail } from 'src/components/Form/Email';
import {
  InputPassword,
  InputPasswordWithRequirements,
} from 'src/components/Form/Password';
import { InputPhone } from 'src/components/Form/Phone';
import { InputText } from 'src/components/Form/Text';
import { Form } from 'src/form';
import { AuthLayout } from 'src/layouts';
import { links } from 'src/router/routes';

import styles from './styles.module.css';
import { FormData, useRegister } from './use-register';

export const Register = memo(() => {
  const { initialValues, isLoading, onSubmit, subtitle, title, validate } =
    useRegister();

  return (
    <AuthLayout title={title} subtitle={subtitle}>
      <Box className={styles.registerPage}>
        <Form<FormData>
          initialValues={initialValues}
          validate={validate}
          onSubmit={onSubmit}
        >
          <Grid gutter={20}>
            <Grid.Col span={6}>
              <InputText
                name="first_name"
                label="First Name"
                placeholder="First Name"
              />
            </Grid.Col>
            <Grid.Col span={6}>
              <InputText
                name="last_name"
                label="Last Name"
                placeholder="Last Name"
              />
            </Grid.Col>
            <Grid.Col span={6}>
              <InputEmail name="email" label="Email" placeholder="Email" />
            </Grid.Col>
            <Grid.Col span={6}>
              <InputPhone
                name="phone_number"
                label="Mobile Number"
                placeholder="Mobile Number"
              />
            </Grid.Col>
            <Grid.Col span={12}>
              <InputPasswordWithRequirements
                name="password"
                label="Password"
                placeholder="Password"
              />
            </Grid.Col>
            <Grid.Col span={12}>
              <InputPassword
                name="confirm_password"
                label="Confirm Password"
                placeholder="Confirm Password"
              />
            </Grid.Col>
            <Grid.Col span={12}>
              <Checkbox
                name="consent"
                label={
                  <span>
                    I agree to the <Link to="/">Terms</Link> and{' '}
                    <Link to="/">Conditions</Link> and{' '}
                    <Link to="/">Privacy Policy</Link>.
                  </span>
                }
              />
            </Grid.Col>
            <Grid.Col span={6} offset={3}>
              <Space h="lg" />
              <Button round variant="filled" loading={isLoading}>
                CREATE AN ACCOUNT
              </Button>
            </Grid.Col>
            <Grid.Col span={12}>
              <Center>
                <Text span className={styles.navLink}>
                  Have an account? <Link to={links.login}>Sign in</Link>
                </Text>
              </Center>
            </Grid.Col>
          </Grid>
        </Form>
      </Box>
    </AuthLayout>
  );
});
